/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Tokens_RevokeInputs */

const en_tokens_revoke = /** @type {(inputs: Tokens_RevokeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoke token ${i?.label}`)
};

const de_tokens_revoke = /** @type {(inputs: Tokens_RevokeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Token ${i?.label} widerrufen`)
};

/**
* | output |
* | --- |
* | "Revoke token {label}" |
*
* @param {Tokens_RevokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_revoke = /** @type {((inputs: Tokens_RevokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_RevokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_revoke(inputs)
	return en_tokens_revoke(inputs)
});